import React, { useState, useEffect, useRef } from "react";
import { useParams, useLocation, useHistory, Link } from "react-router-dom";
import api from "services/api";
import { Modal } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Translator, { __ } from "services/Translator";
import jQuery, { param } from "jquery";
import { useSelector } from "react-redux";
import GameItem from "elements/GameElements/GameItem";

export default function GamePlay(props) {
  const [gameList, setGameList] = useState([]);
  const [gameSorting, setGameSorting] = useState(null);

  const userBalance = useSelector((state) => state.userBalance);

  const getGameList = async () => {
    props.setSpinner(true);
    var response = await api.post("/games/by-category", {
      per_page: 5,
      game_types: ["popular"],
      page: 1,
      game_sorting: gameSorting,
      providers: props.selectedProviders,
    });
    props.setSpinner(false);
    if (response.status === 200) {
      setGameList(response.data.games?.popular?.gamelist ?? []);
    }
  };

  const searchTextBox = useRef(null);

  const focusSearchBar = () => {
    searchTextBox.current.focus();
  };

  // const __ = (text) => text;

  useEffect(() => {
    getGameList();
  }, [gameSorting, props.selectedProviders]);

  const params = useParams();
  const history = useHistory();
  const isAuthenticated = props.isAuthenticated;
  const [launchUrl, setLaunchUrl] = useState("");
  const [gameDetails, setGameDetails] = useState("");
  const [gamePlayMode, setGamePlayMode] = useState(
    params.mode ? params.mode : "real"
  );
  const [gameSessionId, setGameSessionId] = useState(null);

  const toggleFullScreen = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      var element = document.getElementById("game_play_window");
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    }
  };

  const iframeSrcChanged = (event) => {
    // alert(event.target.contentWindow.location);
  };

  const getPlay = async () => {
    var response = await api.post("/game/initsession", {
      slug: params.slug,
      mode: gamePlayMode,
    });

    if (response.status === 200 && response.data) {
      if (response.data.launchUrl) {
        setLaunchUrl(response.data.launchUrl);
      } else if (response.data.launchOptions) {
        setLaunchUrl("");
        setTimeout(() => {
          gameLaunch(response.data.launchOptions);
        }, 1000);
      }
      setGameSessionId(response.data.sessionId);
      setGameDetails(response.data.details);
      setIsFavorite(response.data.is_favorite_game);
    } else {
      setGameDetails(response?.data?.details);
      props.showAlert("Warning!!", response.data.message, true, () => {
        // history.push("/play/" + params.slug + "/demo");
      });
    }
  };

  const gameLaunch = (launchOptions) => {
    jQuery("div#game_play_window").html("");
    var gameLaunchOptions = { target_element: "game_play_window" };
    // launch_options that you've received in start demo or create session response.
    gameLaunchOptions["launch_options"] = launchOptions;
    var success = function (gameDispatcher) {
      console.log("gameDispatcher", gameDispatcher);
    };
    var error = function (error) {
      console.log("errorerror", error);
    };

    window.sg.launch(gameLaunchOptions, success, error);
  };

  useEffect(() => {
    getPlay();
  }, [gamePlayMode, params.slug]);

  const [isFavorite, setIsFavorite] = useState(gameDetails?.is_favorite_game);
  const toggleFavoriteGame = async () => {
    var response = await api.post("/toggle-favorite-game", {
      gameId: gameDetails.id,
    });
    if (response.status === 200) {
      if (response.data.status === "added") {
        setIsFavorite(true);
      } else {
        setIsFavorite(false);
      }
    }
  };

  const [bonusUnsupportedWarningModal, setBonusUnsupportedWarningModal] =
    useState({ show: false });

  useEffect(() => {
    if (
      gameDetails &&
      userBalance &&
      gamePlayMode !== "demo" &&
      !gameDetails.bonus_supported &&
      parseFloat(userBalance.cash_balance) === 0.0
    ) {
      setBonusUnsupportedWarningModal({ show: true });
    } else {
      setBonusUnsupportedWarningModal({ show: false });
    }
  }, [gamePlayMode, userBalance.cash_balance, gameDetails]);

  const closeAllModals = () => {
    setGameHubMessageModal({ show: false });
    setBonusUnsupportedWarningModal({ show: false });
  };

  //GameHub message functionality
  const [gameHubMessageModal, setGameHubMessageModal] = useState({
    title: "",
    message: "",
    show: false,
  });

  const loadGameHubMessage = async () => {
    if (!gameDetails) return;
    var response = await api.post("/load-game-hub_message", {
      provider: gameDetails.game_aggregator,
      game_session_id: gameSessionId,
    });
    if (response.status === 200) {
      if (response.data.type == "found") {
        //There is a message to show.
        var modalData = {
          ...modalData,
          show: true,
          title: __("Warning!!"),
          message: response.data.gamehub_message.message,
          message_type: response.data.gamehub_message.message_type,
        };

        setGameHubMessageModal(modalData);
      } else if (response.data.type == "session_created") {
        //Session type changed. Message to show and game area to reload
        setGameHubMessageModal({
          ...gameHubMessageModal,
          message_type: response.data.gamehub_message.message_type,
          title: __("Balance type changed!"),
          message: response.data.gamehub_message.message,
          show: true,
        });
        setGameSessionId(response.data.newSession.sessionId);
        setLaunchUrl(response.data.newSession.launchUrl);
      }
    }
  };

  useEffect(() => {
    var interval = setInterval(function () {
      if (gamePlayMode !== "demo") {
        loadGameHubMessage();
      }
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [gameSessionId, gameDetails, isAuthenticated, gamePlayMode]);

  //GamePlay Page detection
  const isMobileDevice = props.isMobileDevice;
  const isMobileDeviceByViewPort = props.isMobileDeviceByViewPort;
  const isLandscape = props.isLandscape;
  const [mobileIframeStyle, setMobileIframeStyle] = useState({});
  const calclateMobileIframeStyle = () => {
    var style = {
      width: "100vw",
      height: "calc(100vh - 52px)",
    };
    if (isLandscape) {
      style.height = "100vh";
    }
    setMobileIframeStyle(style);
  };

  useEffect(() => {
    window.addEventListener("resize", () => {
      calclateMobileIframeStyle();
    });
    calclateMobileIframeStyle();

    window.gotoGamesPage = () => {
      history.push("/");
    };
  }, []);

  const [topWinners, setTopWinners] = useState([]);

  const getTopWinners = async () => {
    var response = await api.get("/games/top-winners?limit=5");
    if (response.status === 200) {
      setTopWinners(response.data.data);
    } else {
      console.log(response.data);
    }
  };
  const [detailsTab, setDetailsTab] = useState("Description");
  const [theaterMode, setTheaterMode] = useState(false);
  useEffect(() => {
    getTopWinners();
    // if(isAuthenticated){
    //   setGamePlayMode('real');
    // } else {
    //   setGamePlayMode('demo');
    // }
  }, []);

  const [maximumWagersPerRoundSettings, setMaximumWagersPerRoundSettings] =
    useState([]);
  const getMaximumWagersPerRoundSettings = async () => {
    var response = await api.post("/maximum-wagers-per-round-settings", {
      type: "Cash",
    });
    if (response.status === 200) {
      setMaximumWagersPerRoundSettings(response.data);
      // console.log('maximumWagersPerRoundSettings', response.data);
    }
  };

  const [
    maximumBonusWagersPerRoundSettings,
    setMaximumBonusWagersPerRoundSettings,
  ] = useState([]);
  const getMaximumBonusWagersPerRoundSettings = async () => {
    var response = await api.post("/maximum-wagers-per-round-settings", {
      type: "Bonus",
    });
    if (response.status === 200) {
      setMaximumBonusWagersPerRoundSettings(response.data);
      // console.log('maximumWagersPerRoundSettings', response.data);
    }
  };

  useEffect(() => {
    getMaximumWagersPerRoundSettings();
    getMaximumBonusWagersPerRoundSettings();
  }, []);

  const stats = {
    title: "Total Wins",
    percentage: 72.5,
    change: 2.7,
    negativeChange: -2.45,
    progress: 72.5, // Progress bar value in percentage
    goalTitle: "Month Goals",
  };

  return (
    <>
      {!isMobileDevice && (
        <>
          <div className="container">
            <div className="gameplay-container">
              <div className="row">
                <div className="col-md-9">
                  <div
                    className={
                      "gameplay-area " +
                      (theaterMode ? "theaterModeEnabled" : "")
                    }
                  >
                    {launchUrl !== "" ? (
                      <iframe
                        style={{ display: "block !important;" }}
                        id="game_play_window"
                        width="100%"
                        height="100%"
                        src={launchUrl}
                      ></iframe>
                    ) : (
                      <div
                        style={{
                          display: "block !important",
                          width: "100%",
                          height: "650px",
                        }}
                        id="game_play_window"
                      ></div>
                    )}
                  </div>
                  <div className="game-control-area">
                    <Link className="commonBtn primaryBtn">
                      <span className="front">
                        <svg
                          width="15"
                          height="12"
                          viewBox="0 0 15 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.6543 11L1.6543 6M1.6543 6L6.6543 1M1.6543 6L13.6543 6"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Game Selection
                      </span>
                    </Link>
                    <div className="middle-action-area">
                      <Link className="playIcon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.7519 9.16795L9.5547 7.03647C8.89015 6.59343 8 7.06982 8 7.86852V12.1315C8 12.9302 8.89015 13.4066 9.5547 12.9635L12.7519 10.8321C13.3457 10.4362 13.3457 9.56377 12.7519 9.16795Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Link>
                      <Link className="soundIcon">
                        <svg
                          width="20"
                          height="18"
                          viewBox="0 0 20 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.5355 5.46448C15.4881 7.4171 15.4881 10.5829 13.5355 12.5355M16.364 2.63599C19.8787 6.15071 19.8787 11.8492 16.364 15.3639M3.58579 12.0001H2C1.44772 12.0001 1 11.5523 1 11.0001V7.00005C1 6.44777 1.44772 6.00005 2 6.00005H3.58579L8.29289 1.29294C8.92286 0.66298 10 1.10915 10 2.00005V16.0001C10 16.891 8.92286 17.3371 8.29289 16.7072L3.58579 12.0001Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Link>
                      <Link className="liveIcon">Live</Link>
                    </div>
                    <div className="right-action-area">
                      <Link className="searchIcon">
                        <svg
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.5 19L13.5 13M15.5 8C15.5 11.866 12.366 15 8.5 15C4.63401 15 1.5 11.866 1.5 8C1.5 4.13401 4.63401 1 8.5 1C12.366 1 15.5 4.13401 15.5 8Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Link>
                      <Link className="fullscreenIcon">
                        <svg
                          width="19"
                          height="18"
                          viewBox="0 0 19 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.5 5V1M1.5 1H5.5M1.5 1L6.5 6M17.5 5V1M17.5 1H13.5M17.5 1L12.5 6M1.5 13V17M1.5 17H5.5M1.5 17L6.5 12M17.5 17L12.5 12M17.5 17V13M17.5 17H13.5"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Link>
                      <Link className="settingsIcon">
                        <svg
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.5 15C14.1569 15 15.5 13.6569 15.5 12C15.5 10.3431 14.1569 9 12.5 9C10.8431 9 9.5 10.3431 9.5 12C9.5 13.6569 10.8431 15 12.5 15Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M2.5 12.8794V11.1194C2.5 10.0794 3.35 9.21945 4.4 9.21945C6.21 9.21945 6.95 7.93945 6.04 6.36945C5.52 5.46945 5.83 4.29945 6.74 3.77945L8.47 2.78945C9.26 2.31945 10.28 2.59945 10.75 3.38945L10.86 3.57945C11.76 5.14945 13.24 5.14945 14.15 3.57945L14.26 3.38945C14.73 2.59945 15.75 2.31945 16.54 2.78945L18.27 3.77945C19.18 4.29945 19.49 5.46945 18.97 6.36945C18.06 7.93945 18.8 9.21945 20.61 9.21945C21.65 9.21945 22.51 10.0694 22.51 11.1194V12.8794C22.51 13.9194 21.66 14.7794 20.61 14.7794C18.8 14.7794 18.06 16.0594 18.97 17.6294C19.49 18.5394 19.18 19.6994 18.27 20.2194L16.54 21.2094C15.75 21.6794 14.73 21.3994 14.26 20.6094L14.15 20.4194C13.25 18.8494 11.77 18.8494 10.86 20.4194L10.75 20.6094C10.28 21.3994 9.26 21.6794 8.47 21.2094L6.74 20.2194C5.83 19.6994 5.52 18.5294 6.04 17.6294C6.95 16.0594 6.21 14.7794 4.4 14.7794C3.35 14.7794 2.5 13.9194 2.5 12.8794Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="game-info-area">
                    <div className="heading">
                      <div className="left">Stats</div>
                      <div className="right">...</div>
                    </div>
                    <div className="total-wins-block">
                      <div className="wins-container">
                        <div className="wins-header">
                          <h3>{stats.title}</h3>
                          <div className="negative-change">
                            {stats.negativeChange.toFixed(2)}%
                          </div>
                        </div>
                        <div className="wins-body">
                          <div className="wins-percentage">
                            <span className="percentage-value">
                              {stats.percentage.toFixed(2)}%
                            </span>
                            <span className="percentage-change">
                              + {stats.change.toFixed(1)}%
                            </span>
                          </div>
                          <div className="progress-bar-container">
                            <div
                              className="progress-bar"
                              style={{ width: `${stats.progress}%` }}
                            ></div>
                          </div>
                          <div className="goal-title">{stats.goalTitle}</div>
                        </div>
                      </div>
                    </div>
                    <div className="total-earn-block">
                      <div className="wins-container">
                        <div className="wins-header">
                          <h3>{stats.title}</h3>
                          <div className="negative-change">
                            {stats.negativeChange.toFixed(2)}%
                          </div>
                        </div>
                        <div className="wins-body">
                          <div className="wins-percentage">
                            <span className="percentage-value">
                              {stats.percentage.toFixed(2)}%
                            </span>
                            <span className="percentage-change">
                              + {stats.change.toFixed(1)}%
                            </span>
                          </div>
                          <div className="progress-bar-container">
                            <div
                              className="progress-bar"
                              style={{ width: `${stats.progress}%` }}
                            ></div>
                          </div>
                          <div className="goal-title">{stats.goalTitle}</div>
                        </div>
                      </div>
                    </div>
                    <div className="game-provider-area">
                      <div className="heading">
                        <div className="left">Game Provider</div>
                        <div className="right">...</div>
                      </div>
                    </div>
                    <div className="last-games-played-area">
                      <div className="heading">
                        <div className="left">Last games Played</div>
                        <div className="right">...</div>
                      </div>
                      <div className="games">
                        <ul>
                          <li>
                            <Link>
                              <img
                                alt=""
                                src={require("assets/winnabull/images/common/game-image.png")}
                              />
                            </Link>
                          </li>
                          <li>
                            <Link>
                              <img
                                alt=""
                                src={require("assets/winnabull/images/common/game-image.png")}
                              />
                            </Link>
                          </li>
                          <li>
                            <Link>
                              <img
                                alt=""
                                src={require("assets/winnabull/images/common/game-image.png")}
                              />
                            </Link>
                          </li>
                          <li>
                            <Link>
                              <img
                                alt=""
                                src={require("assets/winnabull/images/common/game-image.png")}
                              />
                            </Link>
                          </li>
                          <li>
                            <Link>
                              <img
                                alt=""
                                src={require("assets/winnabull/images/common/game-image.png")}
                              />
                            </Link>
                          </li>
                          <li>
                            <Link>
                              <img
                                alt=""
                                src={require("assets/winnabull/images/common/game-image.png")}
                              />
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="clearfix"></div>
              </div>

              <div className="game-details-area">
                <div className="game-menus">
                  <Link className="active">Games</Link>
                  <Link>How to play</Link>
                  <Link>Company</Link>
                </div>
                <div className="game-content-area">
                  <div className="game-items">
                    <GameItem
                      game={gameDetails}
                      isAuthenticated={props.isAuthenticated}
                      key={1}
                      props={props}
                    />
                  </div>
                  <div className="game-details">
                    <div className="top-details">
                      <Link className="provider-name">Engineering</Link>
                      <span className="date">October 23, 2024</span>
                    </div>
                    <h2>
                      Accenture on the future of payments and financial
                      automation
                    </h2>
                    <p>
                      Vel egestas ultrices condimentum consectetur enim non elit
                      aenean lacus. Justo rutrum libero urna id quis ipsum.
                      Dictumst vel posuere nec lobortis. Porttitor pretium
                      aenean non pellentesque nunc ultrices commodo sagittis
                      sed. Vulputate duis quis lorem lectus. Et ut viverra eros
                      vulputate.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={
                "game_play d-none" + (theaterMode ? "theaterModeEnabled" : "")
              }
            >
              <div className="row">
                <div className="col-12 col-xl-12">
                  <div className={"game_content "}>
                    <div className="game_head">
                      <div className="game_title">
                        {gameDetails?.game_name
                          ? gameDetails?.game_name
                          : "Game Name"}
                      </div>
                      <div className="game_title">12:30</div>
                    </div>
                    {/* {launchUrl !== "" ? (
                      <iframe
                        style={{ display: "block !important;" }}
                        id="game_play_window"
                        width="100%"
                        height="100%"
                        src={launchUrl}
                      ></iframe>
                    ) : (
                      <div
                        style={{
                          display: "block !important",
                          width: "100%",
                          height: "650px",
                        }}
                        id="game_play_window"
                      ></div>
                    )} */}
                    <div className="clear clearfix"></div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="frame_bottom">
                    <div className="actions_btn">
                      <Link
                        hreflang={Translator.getSelectedLanguage().code}
                        className="home_link"
                        to="/games/all"
                      >
                        <svg
                          fill="#000000"
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 495.398 495.398"
                          xml="preserve"
                        >
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391
				v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158
				c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747
				c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"
                                />
                                <path
                                  d="M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401
				c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79
				c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </Link>
                    </div>

                    <div className="text_area">
                      {isAuthenticated && (
                        <i
                          onClick={toggleFavoriteGame}
                          className={(isFavorite ? "fas" : "far") + " fa-heart"}
                        ></i>
                      )}{" "}
                      {gameDetails?.game_name
                        ? gameDetails?.game_name
                        : "Game Name"}
                    </div>
                    <div className="actions_icon">
                      {/* <SearchBox /> */}

                      <Link hrefLang={Translator.getSelectedLanguage().code}>
                        <OverlayTrigger
                          className="tooltipStyle"
                          overlay={<Tooltip>{__("Theater Mode")}</Tooltip>}
                        >
                          <svg
                            width="20"
                            height="18"
                            viewBox="0 0 20 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_2650_28240)">
                              <path
                                d="M3.7998 3.73633V13.7363H16.2998V3.73633H3.7998ZM4.9998 5.03638H14.9998V12.5364H4.9998V5.03638Z"
                                fill="#8C8C8C"
                              />
                              <path
                                d="M0 12.5371V17.5371H5V16.3371H1.2V12.5371H0Z"
                                fill="#8C8C8C"
                              />
                              <path
                                d="M18.8 12.5371V16.3371H15V17.5371H20V12.5371H18.8Z"
                                fill="#8C8C8C"
                              />
                              <path
                                d="M15 0.0371094V1.23706H18.8V5.03711H20V0.0371094H15Z"
                                fill="#8C8C8C"
                              />
                              <path
                                d="M0 0.0371094V5.03711H1.2V1.23706H5V0.0371094H0Z"
                                fill="#8C8C8C"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2650_28240">
                                <rect width="20" height="17.5" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </OverlayTrigger>
                      </Link>
                      <OverlayTrigger
                        overlay={<Tooltip>{__("Full-Screen")}</Tooltip>}
                      >
                        <Link
                          onClick={toggleFullScreen}
                          hrefLang={Translator.getSelectedLanguage().code}
                        >
                          <svg
                            onClick={() => {
                              if (theaterMode) {
                                setTheaterMode(false);
                              } else {
                                setTheaterMode(true);
                              }
                            }}
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_2650_28247)">
                              <path
                                d="M2.52 14.22L0 11.7V18H6.3L3.78 15.48L7.65 11.61L6.39 10.35L2.52 14.22ZM15.48 3.78L18 6.3V0H11.7L14.22 2.52L10.35 6.39L11.61 7.65L15.48 3.78ZM14.22 15.48L11.7 18H18V11.7L15.48 14.22L11.61 10.35L10.35 11.61L14.22 15.48ZM3.78 2.52L6.3 0H0V6.3L2.52 3.78L6.39 7.65L7.65 6.39L3.78 2.52Z"
                                fill="#8C8C8C"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2650_28247">
                                <rect width="18" height="18" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </Link>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          {/* <CategoryGames
            {...props}
            gameList={gameList}
            categoryName="Popular Games"
            category="popular"
            setGameSorting={setGameSorting}
            gameSorting={gameSorting}
          /> */}
        </>
      )}

      {isMobileDevice && (
        <iframe
          onLoad={iframeSrcChanged}
          src={launchUrl}
          style={mobileIframeStyle}
        />
      )}

      <Modal
        className="gamePlayMsgModal"
        show={gameHubMessageModal.show}
        onHide={closeAllModals}
      >
        {/* <Modal className="gamePlayMsgModal" show={1} onHide={closeAllModals}> */}
        <Modal.Header>
          <h5 className="modal-title" id="exampleModalLabel">
            {gameHubMessageModal.message_type == "maximum_cash_wagers_per_round"
              ? // __("Maximum cash wager limit exceeded!")
                __("Uh oh...")
              : gameHubMessageModal.message_type ==
                "maximum_bonus_wagers_per_round"
              ? __("Maximum bonus wagers limit exceeded!")
              : gameHubMessageModal.message_type == "bonus_balance_not_support"
              ? __("Insufficient balance!")
              : gameHubMessageModal.message_type == "maximum_wagers"
              ? __("Maximum cash wager limit exceeded!")
              : gameHubMessageModal.message_type == "maximum_loss"
              ? __("Maximum cash loss limit exceeded!")
              : gameHubMessageModal.message_type == "maximum_playing_time"
              ? __("Maximum play time limit exceeded!")
              : gameHubMessageModal.title}
          </h5>
          {/* <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeAllModals}
          >
            <span aria-hidden="true">&times;</span>
          </button> */}
        </Modal.Header>
        <Modal.Body className="login_modal forgot_pass">
          <div className="game_message_content">
            <i class="fas fa-exclamation-triangle"></i>
            <br />
            {gameHubMessageModal.message_type ==
            "maximum_cash_wagers_per_round" ? (
              <>
                {/* You have exceeded the maximum bet amount for cash money. Please
                lower the amount and try again. See our{" "}
                <Link hrefLang={Translator.getSelectedLanguage().code} to="">General Terms & Conditions</Link> for more
                information. */}
                {__("Opening month betting limits apply")}
                <br />
                {__("Max Bet")} $
                {gameDetails?.type == "video-slot"
                  ? maximumWagersPerRoundSettings != ""
                    ? maximumWagersPerRoundSettings.slots.limit_amount
                    : ""
                  : gameDetails?.type == "Live Casino"
                  ? maximumWagersPerRoundSettings != ""
                    ? maximumWagersPerRoundSettings.live_casinos.limit_amount
                    : ""
                  : gameDetails?.type == "livecasino"
                  ? maximumWagersPerRoundSettings != ""
                    ? maximumWagersPerRoundSettings.live_casinos.limit_amount
                    : ""
                  : maximumWagersPerRoundSettings != ""
                  ? maximumWagersPerRoundSettings.others.limit_amount
                  : ""}
                <br />
                <br />
                <span style={{ fontSize: "14px" }}>
                  {__("Unlimited bets from May 19")}
                </span>
              </>
            ) : gameHubMessageModal.message_type ==
              "maximum_bonus_wagers_per_round" ? (
              <>
                {/* You have exceeded the maximum bet amount for bonus money. Please
                lower the amount and try again. See our{" "} */}
                {__("Opening month betting limits apply")}
                <br />
                {__("Max Bet")} $
                {gameDetails?.type == "video-slot"
                  ? maximumBonusWagersPerRoundSettings != ""
                    ? maximumBonusWagersPerRoundSettings.slots.limit_amount
                    : ""
                  : gameDetails?.type == "Live Casino"
                  ? maximumBonusWagersPerRoundSettings != ""
                    ? maximumBonusWagersPerRoundSettings.live_casinos
                        .limit_amount
                    : ""
                  : gameDetails?.type == "livecasino"
                  ? maximumBonusWagersPerRoundSettings != ""
                    ? maximumBonusWagersPerRoundSettings.live_casinos
                        .limit_amount
                    : ""
                  : maximumBonusWagersPerRoundSettings != ""
                  ? maximumBonusWagersPerRoundSettings.others.limit_amount
                  : ""}
                <Link hrefLang={Translator.getSelectedLanguage().code} to="">
                  {__("Bonus Terms")}
                </Link>{" "}
                {__("for more information")}.
              </>
            ) : gameHubMessageModal.message_type ==
              "bonus_balance_not_support" ? (
              <>
                {__(
                  "Bonus play is not supported for this game. You do not have sufficient cash balance to play this game"
                )}
                . {__("See our")}{" "}
                <Link hrefLang={Translator.getSelectedLanguage().code} to="">
                  {__("Bonus Terms")}
                </Link>{" "}
                {__("for more information")}. {__("Note")}:{" "}
                {__(
                  "For Live Casino games and Sports Betting, Only cash wagers are accepted"
                )}{" "}
                ({__("no bonus wagers")})
              </>
            ) : (
              <>{gameHubMessageModal.message}</>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="common_btn" onClick={closeAllModals}>
            OK
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={bonusUnsupportedWarningModal.show} onHide={closeAllModals}>
        <Modal.Header>
          <h5 className="modal-title" id="exampleModalLabel">
            {__("Game playing with bonus money!")}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeAllModals}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal.Header>
        <Modal.Body className="login_modal forgot_pass">
          <div className="game_message_content">
            {__(
              "This game is not available for bonus money. Only cash money is accepted."
            )}
            <br />
            {__(
              "Note: All Live Casino games are not available for bonus money wagering."
            )}
            <br />
            <Link hrefLang={Translator.getSelectedLanguage().code} to="/bonus">
              {__("Click here")}
            </Link>{" "}
            {__("to see which games are available for Bonus Money playing.")}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
